import AxiosClient from "../../../services/axios.services";

class RequirementsMonitorServices {
  getRequirementsMonitor = (params) =>
    AxiosClient.get(
      "/api/app/seleccion_contratacion_solicitud_plaza_vacante/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getRequirementsUrls = (params) =>
    AxiosClient.get("/api/app/seleccion_contratacion_solicitud_plan_archivo/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getRequirementsMonitorById = (id) =>
    AxiosClient.get(
      `/api/app/seleccion_contratacion_solicitud_plaza_vacante/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveRequirementsMonitor = (data) =>
    AxiosClient.post(
      "/api/app/seleccion_contratacion_solicitud_plaza_vacante/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveRequirementsUrl = (data) =>
    AxiosClient.post(
      "/api/app/seleccion_contratacion_solicitud_plan_archivo/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editRequirementsMonitor = (id, data) =>
    AxiosClient.put(
      `/api/app/seleccion_contratacion_solicitud_plaza_vacante/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editRequirementsUrl = (id, data) =>
    AxiosClient.put(
      `/api/app/seleccion_contratacion_solicitud_plan_archivo/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteRequirementsMonitor = (id) =>
    AxiosClient.delete(
      `/api/app/seleccion_contratacion_solicitud_plaza_vacante/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );


    deleteRequirementsUrl = (id) =>
    AxiosClient.delete(
      `/api/app/seleccion_contratacion_solicitud_plan_archivo/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  mailSendRequirementsMonitor = (data) =>
    AxiosClient.post(`/api/app/envio_correo_seleccion_contratacion/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  getRequirementDoc = (id) =>
    AxiosClient.get(
      `/api/app/seleccion_contratacion_plan_requerimiento/${id}/`,
      {
        headers: { responseType: "blob" },
      }
    );
}

export default new RequirementsMonitorServices();
